import { gql } from 'src/__generated__'

export default gql(`
  mutation removeFood($id: Int!) {
    removeFood(id: $id)
  }
`)
